

export default class DPBoundingBox {

	static actualizeBottomAndRightInBoundingBox(element) {
		element.bottom = element.top + element.height;
		element.right = element.left + element.width;
		return element;
	}

	static actualizeHeightAndWidthInBoundingBox(element) {
		element.height = element.bottom - element.top;
		element.width = element.right - element.left;
		return element;
	}
	/**
	 * Get an element position on the page
	 * @api private
	 * @method _getOffset
	 * @param {Object} element
	 * @returns Element's position info
	 */
	static getElBoundingBox = (element, includeMargin = false, relativeToCurrentScrollTop = false, defVal = null) => {
		if (element) {
			const jElement = $(element);
			const offset = jElement.offset();
			if (includeMargin) {

				return DPBoundingBox.boundingBox2RelativeScrollPos(DPBoundingBox.actualizeBottomAndRightInBoundingBox({
					top: Math.round(offset.top),
					left: Math.round(offset.left),
					width: Math.round(jElement.outerWidth(false)),
					height: Math.round(jElement.outerHeight(false))
				}), relativeToCurrentScrollTop);
			}
			else {
				return DPBoundingBox.boundingBox2RelativeScrollPos(DPBoundingBox.actualizeBottomAndRightInBoundingBox({
					top: Math.round(offset.top - parseFloat($(jElement).css('marginTop'), 0)),
					left: Math.round(offset.left - parseFloat($(jElement).css('marginLeft'), 0)),
					width: Math.round(jElement.outerWidth(true)),
					height: Math.round(jElement.outerHeight(true))
				}), relativeToCurrentScrollTop);
			}
		}
		else if (defVal == 'EMPTY_OFFSET') {
			return DPBoundingBox.boundingBox2RelativeScrollPos(DPBoundingBox.actualizeBottomAndRightInBoundingBox({
				top: 0,
				width: 0,
				height: 0,
				left: 0
			}), relativeToCurrentScrollTop);
		}
		return defVal;
	}

	static boundingBox2RelativeScrollPos(boundingBox, enabled = true) {
		const st = $(window).scrollTop();
		const sl = $(window).scrollLeft();
		const boundingBoxNew = { ...boundingBox };
		boundingBoxNew.top -= enabled ? st : 0;
		boundingBoxNew.left -= enabled ? sl : 0;
		boundingBoxNew.bottom -= enabled ? st : 0;
		boundingBoxNew.right -= enabled ? sl : 0;
		return boundingBoxNew;
	}

	static mergeBoundingBoxes(...boundingBoxes) {
		if (boundingBoxes.length) {
			const notNulBBs = boundingBoxes.filter(bb => bb);
			const tops = notNulBBs.map(bb => bb.top);
			const lefts = notNulBBs.map(bb => bb.left);
			const bottoms = notNulBBs.map(bb => bb.bottom);
			const rights = notNulBBs.map(bb => bb.right);

			if (tops && tops.length && lefts && lefts.length && bottoms && bottoms.length && rights && rights.length) {
				return DPBoundingBox.actualizeHeightAndWidthInBoundingBox({
					top: Math.min(...tops),
					left: Math.min(...lefts),
					right: Math.max(...rights),
					bottom: Math.max(...bottoms)
				});
			}
		}
		return null;
	}

	static intersectBoundingBoxes(...boundingBoxes) {
		if (boundingBoxes.length) {
			const notNulBBs = boundingBoxes.filter(bb => bb);
			const tops = notNulBBs.map(bb => bb.top);
			const lefts = notNulBBs.map(bb => bb.left);
			const bottoms = notNulBBs.map(bb => bb.bottom);
			const rights = notNulBBs.map(bb => bb.right);

			if (tops && tops.length && lefts && lefts.length && bottoms && bottoms.length && rights && rights.length) {
				return DPBoundingBox.actualizeHeightAndWidthInBoundingBox({
					top: Math.max(...tops),
					left: Math.max(...lefts),
					right: Math.min(...rights),
					bottom: Math.min(...bottoms)
				});
			}
		}
		return null;
	}

	_mergeElementsBoundingBoxes(...elements) {
		return DPBoundingBox.mergeBoundingBoxes(...elements.map(el => DPBoundingBox.getElBoundingBox(el)));
	}
}